<div class="balance-card balance-card-{{size}}">
  <span class="balance-card-font-1-{{size}}">{{ value }}</span>
  <span class="balance-card-font-2-{{size}} mb-2">{{ label }}</span>
</div>
